import React, { useEffect } from "react";
import "./BlogMain3.css";
import { useLocation } from "react-router-dom";
import { blogContent } from "../../Data/BlogData";
import NavComponent from "../../components/NavComponent";
import SEOHelmet from "../../components/SEOHelmet";
import { blogJsonLd } from "../../Data/SEO-JsonData";

export const BlogMain3 = () => {
  const location = useLocation();
  const { state } = location;
  // const BlogDetails = blogContent.find((item, index) => item.id === state);
  const BlogDetails = blogContent[3];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="element">
      <SEOHelmet
        title="How Agentic AI Will Transform Healthcare Claims Automation in 2026 and Beyond | Canvendor"
        description="Discover how Agentic AI is transforming healthcare claims automation in 2026 and beyond. Learn how hospitals and clinics can reduce denials, accelerate reimbursements, and ensure compliance with intelligent claims processing."
        keywords="Agentic AI, healthcare claims automation, AI in healthcare, claims adjudication software, healthcare revenue cycle management, medical billing automation, AI-powered claims processing, Canvendor healthcare AI, HIPAA compliant claims automation"
        url="https://www.canvendor.com/blog/how-agentic-ai-will-transform-healthcare-claims-automation-2026"
        image="https://www.canvendor.com/BlogImages/blogBannerImage.jpg"
        alt="Agentic AI transforming healthcare claims automation in 2026 - Canvendor"
        jsonLd={blogJsonLd}
      />

      <NavComponent></NavComponent>
      <div className="container">
        {/* Header */}
        {/* <header className="header">
          <h1 className="main-title">{BlogDetails.title}</h1>
        </header> */}

        {/* Content Wrapper - Now includes hero image and sidebar */}
        {/* Left Column - Hero Image + Main Content */}
        <div className="main-column">
          {/* Hero Image */}
          <div className="blog-hero-image">
            <img src={BlogDetails?.image} alt="Healthcare AI Technology" />
          </div>

          {/* Main Article */}
          <main className="main-content">
            {/* TL;DR Section */}

            {BlogDetails.sections.map((con, index) => {
              return (
                <section key={index} className="section">
                  {con?.heading && (
                    <h2 className="section-title">
                      <span>{con?.heading || ""}</span>
                      <img
                        className="title-underline"
                        src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                        alt=""
                      />
                    </h2>
                  )}
                  <p className="section-text">{con?.content || ""}</p>
                  <p className="section-text">{con?.content1 || ""}</p>
                  <p className="section-text">{con?.content2 || ""}</p>
                  <p className="section-text">
                    {con?.listHeading || ""}
                    <ul>
                      {con?.list?.map((item, index) => {
                        if (item.includes(":")) {
                          const [boldText, normalText] = item.split(":");
                          return (
                            <li key={index}>
                              <strong>{boldText}:</strong>
                              {normalText}
                            </li>
                          );
                        }
                        return <li key={index}>{item}</li>;
                      })}
                    </ul>
                  </p>
                  <p className="section-text">
                    {con?.listHeading1 || ""}
                    <ul>
                      {con?.list1?.map((item, index) => {
                        if (item.includes(":")) {
                          const [boldText, normalText] = item.split(":");
                          return (
                            <li key={index}>
                              <strong>{boldText}:</strong>
                              {normalText}
                            </li>
                          );
                        }
                        return <li key={index}>{item}</li>;
                      })}
                    </ul>
                  </p>
                  <p className="section-text">{con?.afterListContent || ""}</p>
                </section>
              );
            })}

            <section className="section">
              <h2 className="section-title">
                <span>Author</span>
                <img
                  className="title-underline"
                  src="https://c.animaapp.com/memovagbcMSRxN/img/vector-1.svg"
                  alt=""
                />
              </h2>
              <div className="author-card">
                <img
                  className="author-avatar"
                  src={BlogDetails.author.image}
                  alt={BlogDetails.author.name}
                />
                <div className="author-info">
                  <h3 className="author-name">
                    {BlogDetails.author.name || ""}
                  </h3>
                  <p className="author-title">
                    {BlogDetails.author.role || ""}
                  </p>
                  <p className="author-bio">{BlogDetails.author.bio || ""}</p>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};
